<template>
  <div class="flex justify-between items-center mb-4">
    <!-- Conditional Breadcrumb Title -->
    <div class="text-sm text-gray-500">
      <template v-if="isDashboard">
        <span class="text-gray-900 font-semibold">Dashboard</span>
      </template>
      <template v-else>
        Dashboard / <span class="text-gray-900 font-semibold">{{ title }}</span>
      </template>
    </div>

    <!-- Back Button -->
    <button
      v-if="backPageTitle && !isDashboard"
      @click="goBack"
      class="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
    >
      <CornerUpLeft class="w-5 h-5" />
      <span>{{ backPageTitle }}</span>
    </button>
  </div>
</template>

<script>
import { CornerUpLeft } from 'lucide-vue-next';

export default {
  name: 'PageTitleComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    backPageTitle: {
      type: String
    }
  },
  components: {
    CornerUpLeft
  },
  computed: {
    isDashboard() {
      return this.$route.path === '/dashboard' || this.$route.path === '/';
    }
  },
  mounted() {
    document.title = 'BizMan | ' + this.title;
  },
  methods: {
    goBack() {
      const redirectPath = this.$route.query.redirect || '/';
      this.$router.push(redirectPath);
    }
  }
};
</script>